exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--heading-line-height:1.2;--body-line-height:1.4;--measure:60ch;--spacing-ratio:1.61803398875;--s-base:1rem;--s0:0;--s1:calc(var(--s-base)*0.25);--s2:calc(var(--s-base)*0.5);--s3:calc(var(--s-base)*0.75);--s4:var(--s-base);--s5:calc(var(--s4)*var(--spacing-ratio));--s6:calc(var(--s5)*var(--spacing-ratio));--s7:calc(var(--s6)*var(--spacing-ratio));--s8:calc(var(--s7)*var(--spacing-ratio));--s9:calc(var(--s8)*var(--spacing-ratio));-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
